import { Link, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { buildNavigationSections, hasRootAccess } from "../Header/navigationConfig";
import styles from "./LogisticsHome.module.css";

const LogisticsHome = () => {
  const { currentUser } = useSelector((state) => state.common);

  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  const authorities = currentUser.authorities || [];
  if (!hasRootAccess(authorities)) {
    return <Navigate to="/403" replace />;
  }

  const sections = buildNavigationSections(authorities);
  const firstName = currentUser.firstName || "";
  const fullName = [currentUser.lastName, currentUser.firstName].filter(Boolean).join(" ");
  const roleLabel = authorities.map((item) => item.authority).join(", ");

  return (
    <div className={styles.page}>
      <div className={styles.glow} />
      <header className={styles.hero}>
        <p className={styles.eyebrow}>Logistics Control Center</p>
        <h1 className={styles.title}>
          {firstName ? `${firstName}, откройте нужный модуль` : "Выберите рабочий модуль"}
        </h1>
        <p className={styles.subtitle}>
          Главная страница собрала все разделы меню в одном месте. Быстрый вход в операции,
          тарифы, мониторинг и интеграции.
        </p>
        <div className={styles.identity}>
          <span className={styles.identityItem}>
            <i className="pi pi-user" /> {fullName || "Пользователь"}
          </span>
          <span className={styles.identityItem}>
            <i className="pi pi-shield" /> {roleLabel || "Без роли"}
          </span>
        </div>
      </header>

      <section className={styles.sectionGrid}>
        {sections.map((section, index) => (
          <article
            key={section.label}
            className={styles.sectionCard}
            style={{ animationDelay: `${0.06 * index}s` }}
          >
            <header className={styles.sectionHeader}>
              <span className={styles.sectionIcon}>
                <i className={section.icon} />
              </span>
              <div className={styles.sectionMeta}>
                <h2>{section.label}</h2>
                <p>{section.description}</p>
              </div>
            </header>

            <div className={styles.sectionList}>
              {section.items.map((item) => (
                <Link key={item.path} to={item.path} className={styles.moduleLink}>
                  <span className={styles.moduleIcon}>
                    <i className={item.icon} />
                  </span>
                  <span className={styles.moduleText}>
                    <strong>{item.label}</strong>
                    <small>{item.description}</small>
                  </span>
                  <i className={`pi pi-angle-right ${styles.moduleArrow}`} />
                </Link>
              ))}
            </div>
          </article>
        ))}
      </section>
    </div>
  );
};

export default LogisticsHome;
